import { render, staticRenderFns } from "./SaveCustomer.vue?vue&type=template&id=12b64e65&scoped=true&"
import script from "./SaveCustomer.vue?vue&type=script&lang=js&"
export * from "./SaveCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SaveCustomer.vue?vue&type=style&index=0&id=12b64e65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b64e65",
  null
  
)

export default component.exports